/**
 * A global namespace for `Escape` key.
 * e.which = 27 equivalent
 */
const keyEscape = 'Escape';

export default keyEscape;
